import { gql } from '@apollo/client';

export const UPDATE_USER_PAGE_CONFIG = gql`
  mutation updateUserPageConfig($pageId: String!, $configuration: String!) {
    UpdateUserPageConfig(pageId: $pageId, configuration: $configuration) {
      userPageConfiguration
    }
  }
`;
